import { IPageOf } from '@howdeniberia/core-front';
import { Observable } from 'rxjs';
import { IClientDto } from '../../../models/client.dto';
import { IClientsFilterDto } from '../../../models/clients-filter.dto';

export abstract class ClientsContract {
  abstract searchClients(filter: IClientsFilterDto): Observable<IPageOf<IClientDto>>;
}
